import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Paper from '@mui/material/Paper';
import { useAppSelector } from '../../redux/store';
import { ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR } from '../../styles/colors';
import { PANEL_CONTENT_PADDING_STRING } from '../../styles/styles';
import { range } from '../../utils/utils';
import { PanelHeader } from '../panelHeader';
import { PanelContainer } from '../panelStyles';
import { PlayerPanelItem, selectPlayersArray } from './playerPanelItem';
const PAPER_CSS = css `
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR} !important;
  display: flex;
  flex-direction: column;
`;
export const PlayersPanel = () => {
    const numPlayers = useAppSelector((state) => selectPlayersArray(state)?.length || 0);
    return (_jsxs(PanelContainer, { padding: PANEL_CONTENT_PADDING_STRING, "aria-label": 'players panel', children: [_jsx(PanelHeader, { title: 'Players' }), _jsx(Paper, { "aria-label": 'players list', component: 'section', css: PAPER_CSS, children: range(numPlayers).map((playerIndex) => (_jsx(PlayerPanelItem, { playerIndex: playerIndex }, playerIndex))) })] }));
};
